import { render, staticRenderFns } from "./PrintTienDanPhong.vue?vue&type=template&id=0ffe8e9e&"
import script from "./PrintTienDanPhong.vue?vue&type=script&lang=js&"
export * from "./PrintTienDanPhong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports